import React from "react";

const BentoGrid = ({ features }) => {
  return (
    <div className="relative z-20 max-w-7xl mx-auto">
      <div className="relative">
        <div className="grid grid-cols-1 lg:grid-cols-6 mt-12 xl:border rounded-md dark:border-neutral-800">
          {features.map((feature) => (
            <FeatureCard key={feature.title} image={feature.image} className={feature.className}>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureCard>
          ))}
        </div>
      </div>
    </div>
  );
};

const FeatureCard = ({ children, className, image }) => {
  return (
    <div className={`p-4 sm:p-8 relative overflow-hidden ${className}`}>
      {image && (
        <img src={image} alt="Feature" className="w-full h-auto rounded-lg object-cover mb-4" />
      )}
      {children}
    </div>
  );
};

const FeatureTitle = ({ children }) => {
  return (
    <p className="max-w-5xl mx-auto text-left tracking-tight text-black dark:text-white text-xl md:text-2xl md:leading-snug">
      {children}
    </p>
  );
};

const FeatureDescription = ({ children }) => {
  return (
    <p className="text-sm md:text-base max-w-4xl text-left mx-auto text-neutral-500 font-normal dark:text-neutral-300">
      {children}
    </p>
  );
};

export default BentoGrid;


